import type { FC } from 'react'
import { RouteProps } from 'react-router-dom'
import { usePrompt } from '~/components/prompt'
import { getConfig } from '~/config'

type Props = RouteProps & {
  context?: string
}

export const WarnBeforeLeaving: FC<Props> = ({ context = undefined, children }) => {
  const { basePath } = getConfig()
  usePrompt(({ location }) => location.pathname.startsWith(`${basePath}${context}`))

  return children
}
